import { Box } from "@mui/material"
import { UserModal } from "./UserModal"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { ClientData, UserData } from "../../types";
import { useAuth } from "../../assets/contexts/AuthContext";
import { useAPI } from "../../hooks/useAPI";

interface EditUserProps {
  clients: ClientData[];
  refetchUsers: () => void;
}

export const EditUser = ( { clients, refetchUsers }: EditUserProps ) => {
  const { user_id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { fetchData } = useAPI();
  const [user, setUser] = useState<UserData>({});
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();

  const handleClose = () => {
    setOpen(false);
    navigate('/users');
  }

  const handleSave = () => {
    navigate('/users');
    refetchUsers();
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/users/${user_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setUser(data);
        setOpen(true);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [isAuthenticated, user_id]);

  return (
    <Box className="edit-user">
      <UserModal open={open} handleClose={handleClose} handleSave={handleSave} clients={clients} user={user} />
    </Box>
  )
}